import { Stack, Text } from "@chakra-ui/react";

import CustomLink from "components/Chakra/CustomLink";
import { IMyOffer } from "utils/offer";

type HeaderType = {
  offers: Array<IMyOffer>;
};

const Header: React.FC<HeaderType> = ({ offers }) => (
  <Stack justify="center" alignItems="center" direction="column" spacing="0px">
    {!offers.length && (
      <Text variant="large_2" textAlign="center" mb="15px" fontWeight="bold">
        Zatím u nás nemáte žádný inzerát.
      </Text>
    )}
    <Text
      variant="large_2"
      textAlign="center"
      mb="24px"
      data-test="myOffers.text"
    >
      {!offers.length
        ? "Vytvoření vám zabere jen pár minut, tak směle do toho."
        : "Spravujte svou inzerci přehledně na jednom místě."}
    </Text>
    <CustomLink
      dataTest="myOffers.addButton"
      variant={!offers.length ? "button" : "button_outline"}
      to="/vlozeni-inzeratu"
      trackEventPayload={{
        "dl.eCat": "inzerce",
        "dl.eAct": "click_vlozit_inzerat",
        "dl.eLab": "moje_inzeraty",
      }}
    >
      Vložit inzerát
    </CustomLink>
  </Stack>
);

export default Header;
